<template>
	<div class="container">
		<!--页面开始-->
		<div class="step_box">
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/step_5.png')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit">1、</div>
				<div class="step_txt">
					洗手。使用流动清水或手部消毒液清洗双手。
				</div>
			</div>
			
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/step_6.png')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit">2、</div>
				<div class="step_txt">
					了解检测流程。仔细阅读配套说明书及相关注意事项。
					<!-- <div class="pad_bot">
						Check <span class="col-red">Expiration Date</span> on the pouch. 
					</div>
					<div class="col-red">
						Do not use expired test kit!
					</div> -->
				</div>
			</div>
			
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/step_7.png')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit">3、</div>
				<div class="step_txt">
					试剂准备。检查试剂是否在保质期内，检查拭子、收集器、检测卡等内容物是否有缺失或破损。如试剂过期或试剂内容物缺失、破损应及时更换检测试剂。
					<!-- <ul>
						<li>Remove the test cassette from the pouch and place it on a clean, &nbsp;flat surface.</li>
						<li>Insert the tube in the pre-made hole on the back of the kit box.</li>
						<li>Remove the foil from the top of the tube.</li>
					</ul> -->
				</div>
			</div>
		</div>
		<div class="btn_box">
			<van-button
				type="primary"
				block
				color="#4f56fe"
				@click="goStepThree"
			>
				下一步
			</van-button>
		</div>
		<!--页面开始-->
	</div>
</template>

<script>
import { shareUrl } from '@/utils/wxshare'

export default {
	components:{
		//
	},
	data() {
		return {
			//
		}
	},
	beforeCreate() {
		document.querySelector('body').setAttribute('style', 'background-color:#fbfbfb;');
	},
	created(){
		if(!localStorage.getItem('token')) {
			this.$router.push({path:'/login'});
		}
	},
	mounted() {
		let that = this;
		that.$nextTick(() => {
			setTimeout(() => {
				window.scrollTo(0, 0);
			}, 50);
			//微信分享
			shareUrl(that);
		});
	},
	watch: {
		//
	},
	methods: {
		goStepThree() {
			this.$router.push({path:'/steptwo'});
		},
	},
	beforeDestroy() {
		document.querySelector('body').removeAttribute('style');
	},
	destroyed() {
		//
	}
}
</script>
</script>

<style scoped>
.container{
	/* position: absolute;
	height: 100%;
	background-color: #fbfbfb; */
}
.step_box{
	position: relative;
	padding: 0.32rem 0.32rem 0 0.32rem;
}
.step_box .step_el{
	background-color: #ffffff;
	margin-bottom: 0.32rem;
	border-radius: 0.32rem;
	box-shadow: 0 0 0.4rem rgb(0, 0, 0, 0.1);
	overflow: hidden;
	position: relative;
	border: 1px solid #E9E9E9;
}
.step_box .step_el:last-child{
	margin-bottom: 0;
}
/* .step_box, .btn_box{background-color: #fbfbfb;} */
.step_box{padding-bottom: 0.64rem !important;}
/*步骤下说明文字*/
.step_txt{
	padding: 0.533rem 0.64rem 0.427rem 0.64rem;
	color: #333333;
}
.step_box img{
	width: 100%;
	height: auto;
}
.step_box .step_el{
	position: relative;
}
.step_box .step_el:last-child{
	padding-bottom: 0;
}
.step_box .step_el .tit{
	position: absolute;
	top: 0.32rem;
	left: 0.32rem;
	font-size: 0.533rem;
	color: #333333;
	font-weight: bold;
}
.btn_box{padding:0rem 0.9rem 1.107rem 0.9rem;}
.step_box img, .btn_box img{width: 100%;}

.step_txt .pad_bot{
	padding-bottom: 0.1rem;
}
ul li{
	padding: 0 0 0.1rem 0;
}
ul li:last-child{
	padding-bottom: 0;
}

>>> .van-button{height: 1.2rem;}
>>> .van-button__text{color: #ffffff;font-size: 0.48rem;font-weight: bold;}
</style>
